var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
define(["require", "exports", "jquery", "./addressBar", "./context", "./productImages", "./querystring", "./addressBar", "./debounce", "./images", "./assetFilter", "./analytics", "./customDesign", "./number"], function (require, exports, $, addressBar_1, context_1, productImages_1, querystring_1, addressBar_2, debounce_1, images_1, assetFilter_1, analytics_1, customDesign_1, number_1) {
    "use strict";
    exports.__esModule = true;
    function updateFringeColor(color, fringeForm) {
        if (color && fringeForm) {
            var $select = $('select[name="' + fringeForm + '"]');
            var val;
            var colors;
            var index = void 0;
            if (!$select.length) {
                $select = $('input[name="' + fringeForm + '"]');
                var $ul = $select.prev('ul');
                if ($ul.length) {
                    colors = $ul.find('li').map(function (i, opt) { return $(opt).text().trim().split(/\s?-\s?/).pop(); }).toArray();
                    index = colors.indexOf(color);
                    $($ul.find('li')[index]).click();
                }
                else if (typeof _fringeColorMap !== 'undefined') {
                    for (var t in _fringeColorMap) {
                        if (t.match("-\\s?" + color)) {
                            var val_1 = _fringeColorMap[t];
                            $select.val(val_1.id);
                            $select.data('decimal', val_1.decimal);
                            break;
                        }
                    }
                }
                val = $select.data('decimal');
            }
            else {
                colors = $select.find('option').map(function (i, opt) { return $(opt).text().trim().split(/\s?-\s?/).pop(); }).toArray();
                index = colors.indexOf(color);
                $($select.find('option')[index]).prop('selected', true);
                val = $select.find('option:selected').data('decimal');
                $select.change();
            }
            addressBar_1.setHashQuery($select.data('attribute-name'), val);
        }
    }
    function fetchProductPictures(params) {
        var url = params.url;
        var productId = params.productId;
        var appendProductId = params.appendProductId;
        var appending = params.appending || 0;
        var fringeForm = params.fringeForm;
        var isTrigger = params.isTrigger;
        var parts = url.split('?');
        var query = querystring_1.parseQuery('?' + parts[1]);
        query['productId'] = "" + productId;
        parts[1] = querystring_1.formatQuery(query);
        var nextProductId = appendProductId;
        $.get(parts.join(''), function (data) {
            var pictures = data.pictures || data;
            productImages_1.fillFabricPicturesForStyle({
                details: $.map(pictures, function (x) { return x.detail; }),
                thumbs: $.map(pictures, function (x) { return x.thumb; }),
                fullImages: $.map(pictures, function (x) { return x.full; }),
                appending: appending,
                previewAvailable: params.previewAvailable,
                attributeName: params.attributeName
            }, appending);
            if (!isTrigger) {
                updateFringeColor(data.fringeColor, fringeForm);
            }
            if (nextProductId) {
                fetchProductPictures({
                    url: url,
                    productId: nextProductId,
                    appending: pictures.length,
                    isTrigger: isTrigger,
                    previewAvailable: params.previewAvailable,
                    attributeName: params.attributeName
                });
            }
            else {
                var title = $('head title').text();
                if (location.pathname.startsWith('/catalog/customize')) {
                    addressBar_2.updateAddress('/catalog/customize/' + title.replace(/\s+/g, '-'), context_1["default"].getQuery(), null, title);
                }
                else {
                    addressBar_2.updateAddress('/p/' + productId + '/' + title.replace(/\s+/g, '-'), context_1["default"].getQuery(), null, title);
                }
                ensureMobilePictureShown();
            }
        });
    }
    function ensureMobilePictureShown() {
        if (context_1["default"].isMobile()) {
            var top_1 = parseFloat($($('.overview')[0]).css('top'));
            window.scrollTo(0, Math.round(top_1));
        }
    }
    exports.ensureMobilePictureShown = ensureMobilePictureShown;
    function switchToAssetPicture(pictureGet, fringeForm, attributeName, assetId, defaultAssetId, defaultProductId, previewAvailable, isTrigger) {
        var fetchParams = {
            url: pictureGet,
            attributeName: attributeName,
            fringeForm: fringeForm,
            isTrigger: isTrigger,
            previewAvailable: previewAvailable
        };
        if (assetId == defaultAssetId) {
            var unmatchedPictures = context_1["default"].isMobile()
                ? $('.defaultPicture.photo-viewport .no-img').length == 0
                : $('.picturethumbs .productPicture:hidden').length > 0;
            if (unmatchedPictures) {
                fetchProductPictures(__assign({}, fetchParams, { productId: defaultProductId, isTrigger: false }));
                context_1["default"].goodProductPicturesAvailable = true;
            }
        }
        else {
            if (_fabricProductGroupMapping && _fabricProductGroupMapping[assetId]) {
                fetchProductPictures(__assign({}, fetchParams, { productId: _fabricProductGroupMapping[assetId] }));
                context_1["default"].goodProductPicturesAvailable = true;
            }
            else {
                var repId = $('input[name="repProductId"]').val();
                fetchProductPictures(__assign({}, fetchParams, { productId: assetId, appendProductId: repId }));
                context_1["default"].goodProductPicturesAvailable = false;
            }
        }
    }
    function createOnAssetSwitch(attributeName, categoryMap, pictureGet, defaultAssetId, defaultProductId, previewAvailable) {
        return function () {
            var assetId = $('input:hidden[data-attribute-name="' + attributeName + '"]').val();
            var assetImage = $('#picker_' + attributeName
                + ' a.asset  img.asset[data-asset_id="' + assetId + '"]');
            var assetSrc = assetImage.attr('src');
            var assetLink = assetImage.data('asset_link');
            updateCurrentAssetLinks(attributeName, assetSrc, assetLink);
            var fabricTitle = categoryMap[assetId].name;
            var $picker = assetImage.closest('.attribute-line');
            updateProductTitleFromFabricName(fabricTitle, assetLink, $picker);
            switchToAssetPicture(pictureGet, null, attributeName, assetId, defaultAssetId, defaultProductId, previewAvailable);
        };
    }
    function setupWindowStateWatch(onAssetSwitch, onAssetClear) {
        if (!$('body').data('onpopstate')) {
            $('body').data('onpopstate', true);
            window.onpopstate = function (e) {
                var query = context_1["default"].getQuery();
                if (!$.isEmptyObject(query)) {
                    addressBar_1.setAttributesFromHash();
                    var fields = $('input[data-attribute-id]');
                    if (fields.length) {
                        $(fields[0]).change();
                    }
                    onAssetSwitch();
                }
                else {
                    onAssetClear();
                }
            };
        }
    }
    function updateProductTitle(title) {
        $('head title').text(title);
        $('h1[itemprop="name"]').text(title);
        $('.productname').text(title);
        $('.breadcrumb a:last').text(title);
    }
    function updateProductTitleFromFabricName(fabricName, fabricLink, $container) {
        $container = $container && $container.length ? $container : $('body');
        $container.find('#fabricTitle').html(fabricName);
        if (fabricLink) {
            $('#getFabricSample').attr('href', decodeURI(fabricLink));
        }
        var template = $('input[name="repProductName"]').val();
        if (template == undefined) {
            return;
        }
        var title = template.replace("{fabric name}", fabricName);
        updateProductTitle(title);
    }
    function setupSelectedAttribute(attributeName, attributePanelId, gradeAttributeName) {
        var $input = $('input:hidden[data-attribute-name="' + attributeName + '"]');
        var assetId = currentAssetId(attributeName);
        var pickerId = attributePanelId || "picker_" + attributeName;
        var $picker = $("#" + pickerId);
        if (assetId && $picker.length) {
            var $img = $picker.find('img[data-asset_id="' + assetId + '"]');
            if ($img.length) {
                var assetImage = $img.attr('src');
                $('#' + attributeName + 'ThumbImageSelector').attr('src', assetImage);
                $('#' + attributeName + '_link').attr('href', currentAssetLink(attributeName)).toggleClass('hidden', false);
                $img.closest('a.asset').click();
            }
            else if (gradeAttributeName) {
                $("input[data-attribute-name=\"" + gradeAttributeName + "\"]").trigger('change');
            }
        }
    }
    exports.setupSelectedAttribute = setupSelectedAttribute;
    function currentAssetLink(attributeName) {
        var $assetImage = $('#picker_' + attributeName
            + ' a.asset  img.asset[data-asset_id="' + currentAssetId(attributeName) + '"]');
        return $assetImage.data('asset_link');
    }
    function currentAssetId(attributeName) {
        var $input = $("input[data-attribute-name='" + attributeName + "']");
        return number_1.firstNumber($input.data('decimal') * 1, $input.val() * 1);
    }
    function hasValidAsset(attributeName) {
        if (context_1["default"].isMobile()) {
            var curAssetId_1 = currentAssetId(attributeName);
            var assets = $("#picker_" + attributeName + " a.asset img.asset").filter(function (i, asset) {
                return $(asset).data('asset_id') == curAssetId_1;
            });
            return assets.length > 0;
        }
        else {
            return !!$("#" + attributeName + "ThumbImageSelector").attr('src');
        }
    }
    exports.hasValidAsset = hasValidAsset;
    function updateCurrentAssetLinks(attributeName, assetImage, assetLink) {
        $("#" + attributeName + "ThumbImageSelector").attr('src', assetImage);
        $("#" + attributeName + "_link").attr('href', assetLink).toggleClass('hidden', !assetLink);
    }
    function watchForGradeChange($grade, $list) {
        $grade.on('radioSelect:change', function (e, assetId) {
            var $asset = $list.find(".asset-box[data-decimal=\"" + assetId + "\"]");
            var assetGrade = $asset.data('asset_grade');
            number_1.setFieldNumberVal($grade, assetGrade);
        });
    }
    exports.watchForGradeChange = watchForGradeChange;
    function setupAttriubtePickerSelector(categoryMap, attributeName, gradeAttributeName, fringeForm, fabricCodeAttributeName, pictureGet, defaultAssetId, defaultProductId, previewAvailable, attributePanelId, matchingProductAttributeName, additionalAction) {
        defaultAssetId = defaultAssetId;
        attributePanelId = attributePanelId ? attributePanelId : ("picker_" + attributeName);
        $('#' + attributePanelId + ' a.asset').click(function (e) {
            e.preventDefault();
            var prevAssetValid = hasValidAsset(attributeName);
            var $asset = $(e.currentTarget);
            var $img = $asset.find('img.asset');
            var assetId = $img.data('asset_id');
            var assetImage = $img.attr('src');
            var assetLink = $img.data('asset_link');
            var categoryId = $asset.closest('.asset-picker').data('category_id');
            var fabricMap = window["fabricMap_" + categoryId];
            var fabric = fabricMap[assetId];
            var fabricDesc = fabric.description;
            var fabricMaterial = fabric.material || $('<dvi></div>').html(fabricDesc).find('p').filter(function (i, p) { return $(p).text().trim(); }).last().text();
            fabric.material = fabricMaterial;
            var $fabricMaterialText = $("#" + attributeName + "Material");
            $fabricMaterialText.text(fabricMaterial);
            if (!assetImage || assetImage === '#') {
                assetImage = $img.data('src');
            }
            var assetGrade = $img.data('asset_grade');
            var $idAttribute = $('input:hidden[data-attribute-name="' + attributeName + '"]');
            $idAttribute.data('decimal', assetId).val(assetId);
            if (!e.isTrigger) {
                $idAttribute.removeData("using_matching");
            }
            updateCurrentAssetLinks(attributeName, assetImage, assetLink);
            var $grade = $('input:hidden[data-attribute-name="' + gradeAttributeName + '"]');
            var oldGrade = $grade.val();
            $grade.data('decimal', assetGrade).val(assetGrade);
            if (attributePanelId !== 'panel3-5') {
                var assetDiscount = $img.data('asset_discount') || '0.0';
                var $discount = $('input:hidden[data-attribute-name="fabricDiscount"]');
                $discount.data('decimal', assetDiscount).val(assetDiscount);
            }
            var $codeName = $('input:hidden[data-attribute-name="' + fabricCodeAttributeName + '"]');
            $codeName.val($img.attr('codeName'));
            if (matchingProductAttributeName) {
                var matchingProductId = $img.data('matching_product_id');
                var $matchingProductId = $("input:hidden[data-attribute-name=\"" + matchingProductAttributeName + "\"]");
                $matchingProductId.data('decimal', matchingProductId).val(matchingProductId);
                $matchingProductId.change();
            }
            var fabricTitle = categoryMap[assetId].name;
            updateProductTitleFromFabricName(fabricTitle, assetLink, $img.closest('.attribute-line'));
            if (assetGrade != oldGrade || !prevAssetValid) {
                $grade.trigger('change');
            }
            addressBar_1.setHashQuery(attributeName, assetId);
            addressBar_1.setHashQuery(gradeAttributeName, assetGrade);
            switchToAssetPicture(pictureGet, fringeForm, attributeName, assetId, defaultAssetId, defaultProductId, previewAvailable, e.isTrigger);
            if (!context_1["default"].isMobile()) {
                var $picker = $("#" + attributePanelId + ":visible");
                $picker.find('a.asset.selected').toggleClass('selected', false);
                $(e.currentTarget).toggleClass('selected', true);
                if ($picker.length) {
                    var customDesign = $picker.closest('.customDesignFabric');
                }
            }
            else {
                var $panel = e.isTrigger ? $asset.closest('.attribute-panel') :
                    $('.attribute-panel.shown');
                var $button = $panel.prev('.attribute-button');
                var $current = $button.find('.attribute-current');
                if (!e.isTrigger) {
                    if ($panel.length) {
                    }
                    else {
                        analytics_1["default"]('product', 'changed', attributeName);
                        setTimeout(function () {
                            $('.price-sheet-current').actionBar('refresh');
                        }, 10);
                    }
                }
                $current.text($img.attr('title'));
                var $thumb = $button.find('.attribute-thumbnail');
                if (!$thumb.length) {
                    $thumb = $('<img class="attribute-thumbnail"/>').appendTo($button);
                }
                $thumb.attr('src', assetImage);
                $button.toggleClass('missing', false);
                var panelId = $asset.closest('.attribute-panel').attr('id');
                if (panelId === 'panel3') {
                    setMatchingFabricFilter($('#panel3-5'));
                }
            }
            additionalAction();
        });
        setupSelectedAttribute(attributeName, attributePanelId, gradeAttributeName);
        setupWindowStateWatch(createOnAssetSwitch(attributeName, categoryMap, pictureGet, defaultAssetId, defaultProductId, previewAvailable), function () {
            fetchProductPictures({
                productId: defaultProductId,
                url: pictureGet,
                previewAvailable: previewAvailable
            });
            $('#' + attributeName + 'ThumbImageSelector').attr('src', null);
            $("#" + attributeName + "_link").toggleClass('hidden', true);
        });
    }
    exports.setupAttriubtePickerSelector = setupAttriubtePickerSelector;
    function setMatchingFabricFilter($picker) {
        var mainFabricGrade = parseInt($('input[data-attribute-name="fabricGrade"]').val());
        var gradeFilter = [];
        for (var i = 1; i <= mainFabricGrade; i++) {
            gradeFilter.push("" + i);
        }
        var settings = { 'grade': gradeFilter };
        var provider = $picker.data('filterProvider');
        if (provider) {
            settings = provider.settings = $.extend(provider.settings || {}, settings);
        }
        var count = assetFilter_1.applyAssetFilters($picker, settings, exports.assetFilterOptions);
        if (provider) {
            provider.setCurrentCount(count);
            provider.setFilterChoices(settings);
        }
    }
    exports.assetFilterOptions = {
        sel: 'img.asset',
        choiceIdPrefix: '',
        getAssetGrade: function (x) { return x.data('asset_grade'); },
        getAssetId: function (x) { return x.data('asset_id'); },
        getSortedBox: function (x) { return x.closest('.asset-box'); },
        getSortedList: function ($dlg) { return $dlg.find('div.asset-picker'); }
    };
    function setupProductPickerAction(actionId) {
        $(actionId).click(debounce_1["default"](function (e) {
            e.preventDefault();
            var $button = $(e.currentTarget);
            var href = $button.attr('href');
            var $picker = $(href);
            var $customDesign = $picker.closest('.customDesignFabric');
            if ($customDesign.length) {
                analytics_1["default"]('customize', 'select_fabricId');
            }
            if ($picker.is(':visible')) {
                $picker.dialog('close');
            }
            else {
                images_1.ensureImageLoaded($picker.find('img[src="#"]')
                    .add($picker.find('img.asset[src="#"]')));
                $picker.dialog('show');
                if (!$picker.data('filter-setup')) {
                    assetFilter_1.setupFilter($picker, __assign({}, exports.assetFilterOptions, { choiceIdPrefix: actionId }));
                    $picker.data('filter-setup', true);
                }
                if ($button.attr('id') === 'fabric2Id') {
                    setMatchingFabricFilter($picker);
                    $('#matchingFabricApplication').toggleClass('hidden', false);
                }
                var $cur = $picker.find('a.asset.selected');
                if ($cur.length) {
                    var $box = $cur.closest('.asset-picker.picturethumbs');
                    var curHeight = $cur.height();
                    var scrollTop = $cur.position().top;
                    if ($box.length && scrollTop > $box.height() - curHeight) {
                        $box.scrollTop(scrollTop - curHeight);
                    }
                }
                if ($picker.closest('.customDesignFabric').length) {
                    $picker.find('.continue').click(customDesign_1.onClickNext);
                }
            }
        }, 400, true));
    }
    exports.setupProductPickerAction = setupProductPickerAction;
    $(function () {
        $('.product-group-item.current img').click(function (e) {
            $(e.currentTarget).closest('.product-group-products').find('.show-picker-action').click();
        });
    });
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/assetPicker.js
// module id = 31
// module chunks = 0